'use strict';
const angular = require('angular');

import {ISeason, ISeasonUtilsService, IOptionsService, IPickupOption} from '../../interfaces';

export const NUMBER_PAYMENTS = 4;

/*@ngInject*/
export class SeasonUtilsService implements ISeasonUtilsService{

  public getDateForInterval(season: ISeason, number: number) {
    let firstDate = new Date(season.firstEventDate);
    let dateResult = new Date(firstDate.getFullYear(), firstDate.getMonth(), firstDate.getDate(), 0, 0, 0);
    
    dateResult.setDate(dateResult.getDate() + (number*season.eventIntervalInDays));
    return dateResult;
  }

  public getStartDateForPickup(season: ISeason, pickupOption: IPickupOption) {
    let date = new Date(season.firstEventDate);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    return new Date( date.getTime() + 24*60*60*1000*pickupOption.weekDay + pickupOption.startMinute*60*1000);
  }

  public getEndDateForPickup(season: ISeason, pickupOption: IPickupOption) {
    let date = this.getDateForInterval(season, season.numberOfEvents-1);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    return new Date(date.getTime() + 24*60*60*1000*pickupOption.weekDay + pickupOption.startMinute*60*1000);
  }

  public getTimeForPickup(season: ISeason, pickupOption: IPickupOption) {
    let date = new Date(season.firstEventDate);
    date.setDate(date.getDate() + pickupOption.weekDay);
    return date.getDay();
  }

  public getDeadlinesForPayments(season: ISeason) {
    let start = new Date(season.firstEventDate);
    let seasonPeriod = 24*60*60*1000 * (season.numberOfEvents-1) * season.eventIntervalInDays;
    let paymentPeriod = seasonPeriod / NUMBER_PAYMENTS;

    let deadlines: Date[] = [];

    for (let i=0; i<seasonPeriod; i+=paymentPeriod) {
      deadlines.push(new Date(start.getTime() + i));
    }

    return deadlines;
  }

  public getDeadlinesForNumberOfPayments(season: ISeason, numberOfPayments: number) {
    let deadlines: Date[] = [];
    let currentDate = new Date();
    let weekTime = 7*24*60*60*1000;

    //parsing paymentDeadlines in string to date
    let deadlineToDate: Date[] = [];
    for (let p of season.paymentDeadlines) {
      deadlineToDate.push( new Date(p) );
    }
    
    // One payment - it always must be a first payment
    if (currentDate.getTime() < deadlineToDate[0].getTime()) {
      deadlines.push(deadlineToDate[0]);
    } else {
      //If it is after first deadline, the new deadline is a week after the current date
      deadlines.push(new Date(currentDate.getTime() + weekTime));
    }

    // Two payments
    if (numberOfPayments == 2) {
      if (currentDate.getTime() < deadlineToDate[1].getTime() - weekTime) {
        deadlines.push(deadlineToDate[2]);
        
      } else if (currentDate.getTime() < deadlineToDate[2].getTime() - weekTime) {
        deadlines.push(deadlineToDate[3]);
      }

    // Four payments
    } else if (numberOfPayments == 4) {
      if (currentDate.getTime() < deadlineToDate[1].getTime() - weekTime) {
        deadlines.push( new Date(season.paymentDeadlines[1]) );
        deadlines.push( new Date(season.paymentDeadlines[2]) );
        deadlines.push( new Date(season.paymentDeadlines[3]) );

      } else if (currentDate.getTime() < deadlineToDate[2].getTime() - weekTime) {
        deadlines.push(deadlineToDate[3]);
      }
    }
    
    return deadlines;
  }

}

function SeasonResource($resource) {
  'ngInject';
  return $resource('/api/seasons/', {}, {});
}


export default angular.module('terrappApp.seasonUtils', [])
  .factory('Season', SeasonResource)
  .service('SeasonUtils', SeasonUtilsService)
  .name;



// WEBPACK FOOTER //
// ./client/app/services/seasonUtils/seasonUtils.service.ts